import React from 'react';
import { Card } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';

const files = [
  { key: 'manualCaregiversUrl', label: 'manual_caregiversGuide' },
  { key: 'manualParentsUrl', label: 'manual_parentsGuide' },
];

const ManualCard = ({ t, onChangeSelectedInstruction }) => {
  return (
    <>
      {files.map(file => (
        <Card
          key={file.key}
          data-keyofinstruction={file.key}
          onClick={onChangeSelectedInstruction}
          variant="outlined"
          className="my1 p2 pointer flex items-center fw-6 hover:bg-gray-100"
        >
          <DescriptionIcon color="action" className="mr2" />
          {t(file.label)}
        </Card>
      ))}
    </>
  );
};

export default ManualCard;
